import { FileContentResult } from "./file.types";
import { InputType } from "./template.types";

export interface Work {
  id: number;
  matterId: number;
  sheetNumber: number;
  rowNumber: number;
  fieldNumber: number;
}

export interface WorkDto {
  workId: number | null;
  taskTypeId: number;
  externalDataRecordId: number | null;
  registeredVoterFlags: RegisteredVoterFlags;
  fields: WorkField[];
  image: FileContentResult;
  taskName: string;
  taskDescription: string;
  showWholeColumn: boolean;
  canBeInvalid: boolean;
  violationCriteria: ViolationCriterion[];
  matterId: number;
  matterName: string;
  sheetNumber: number;
  rowNumber: number;
  fieldNumber: number;
}

export interface ActiveWorkerDto {
  userId: number;
  fullName: string;
  role: string;
  lastActive: Date;
  timeSpent: number;
  workItemCount: number;
  workIds: number[];
}

export enum Validity {
  Unknown,
  Valid,
  Invalid,
  Strikethrough,
}

export interface WorkField {
  id: number;
  name: string;
  value: string;
  inputType: InputType;
  canBeInvalid: boolean;
  validity: Validity;
  violationCriteria: ViolationCriterion[];
  violationId: number | string | null;
  violationNote: string | null;
}

export interface ViolationCriterion {
  ruleId: number;
  name: string;
}

export enum RegisteredVoterFlags {
  Unknown,
  Valid,
  MismatchedName,
  MismatchedAddress,
  NotRegistered,
}

export interface ValidationForm {
  fields: WorkField[];
  externalDataRecordId?: string;
  registeredVoterFlags: RegisteredVoterFlags;
  searchParams?: Record<string, string>;
}

export interface MatterWorkStatusDTO {
  matterId: number;
  matterName: string;
  matterDueDate: string;
  workStatus: WorkStatus;
  count: number;
}

export interface TaskWorkStatus {
  taskId: number;
  taskName: string;
  workStatus: WorkStatus;
  count: number;
}

export interface WorkSummaryByMatter {
  matterId: number;
  matterName: string;
  matterDueDate: string;
  completed: number;
  total: number;
}

export interface FinishWorkDTO {
  fields: WorkField[];
  externalDataRecordId: string | null;
  registeredVoterFlags: RegisteredVoterFlags;
  workStatusId: WorkStatus;
  isValidationOverride?: boolean;
  searchParams?: Record<string, string>;
}

export enum WorkStatus {
  None = 0,
  Flagged = 1,
  Break = 2,
  Completed = 3,
  Assigned = 4,
}

export enum TaskType {
  None = 0,
  TranscribableField = 1,
  SignatureTableColumn = 2,
  ExternalDataSourceVerification = 4,
  SheetReview = 8,
}

export enum UnreleasedWorkType {
  None,
  FirstLastRow,
  OtherRows,
  Fields,
}

export interface UnreleasedWork {
  unreleasedWorkType: UnreleasedWorkType;
  works: Work[];
}

export interface WorkSummaryForSheet {
  sheetNumber: number;
  columns: WorkSummaryColumn[];
  workItems: WorkSummaryItem[];
}

export interface WorkSummaryColumn {
  columnIndex: number;
  name: string;
}

export interface WorkSummaryItem {
  workId: number;
  rowNumber: number;
  fieldNumber: number;
  workStatus: WorkStatus;
  taskName: string;
  firstColumnIndex: number | null;
  lastColumnIndex: number | null;
}
